<app-common-page-breadcrumbs [pageTitle]="title" *ngIf="this.display=='delivery'" [navigationData]="navigationData"></app-common-page-breadcrumbs>
<app-common-page-breadcrumbs [pageTitle]="title" *ngIf="this.display=='screening' || this.display=='bondedwarehouseScreening'" [navigationData]="navigationData"></app-common-page-breadcrumbs>
<div id="loader"*ngIf="enableLoader"></div>
<div *ngIf="!enableLoader">
<div class="filter-nav overflow-visible">
    <div class="container d-none d-lg-block">
        <div class="d-flex justify-content-between">
          <div class="d-flex">
            <div class="md-semibold-font text-black small p-2 text-nowrap">{{ 'home.productHeader.Filter' | cxTranslate }}</div>
            <div class="mr-2">
              <ng-select [items]="portData" [multiple]="true" [clearable]="false" bindLabel="name" dropdownPosition="bottom"
                groupBy="ports" [selectableGroup]="false" [closeOnSelect]="true" placeholder="{{'shipment.SelectPorts' | cxTranslate}}" bindValue="id"
                [(ngModel)]="selectedPort" notFoundText="No Items Found" (change)="changePorts()">
                <ng-template ng-multi-label-tmp>
                  <span class="filter-count pl-2 text-black">{{selectedPort?.length}}x {{ 'shipment.statusselected' | cxTranslate }}</span>
                </ng-template>
                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                  <input type="checkbox" /><span class="ff-semibold "> Ports</span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  <div>
                    <input *ngIf="item.name!==undefined && item.name!==''" id="{{item.id}}" type="checkbox"
                      [ngModel]="item$.selected" [checked]="item.selected" /> <span>{{item.name}}</span>
                  </div>
                </ng-template>
              </ng-select>
            </div> 

              <div class="mr-2">
                <ng-select [items]="StatusList" [multiple]="true" [clearable]="false" bindLabel="name" dropdownPosition="bottom"
                  groupBy="StatusList" [selectableGroup]="false" [closeOnSelect]="true" placeholder="{{'shipment.SelectStatus' | cxTranslate}}" bindValue="code"
                  [(ngModel)]="selectedStatus" notFoundText="No Items Found" (change)="changeStatus()">
                  <ng-template ng-multi-label-tmp>
                    <span class="filter-count pl-2 text-black">{{selectedStatus?.length}}x {{'shipment.statusselected' | cxTranslate}}</span>
                  </ng-template>
                  <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                    <input type="checkbox" /><span class="ff-semibold "> {{'shipment.status' | cxTranslate}}</span>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <div>
                      <input *ngIf="item.name!==undefined && item.name!==''" id="{{item.code}}" type="checkbox"
                        [ngModel]="item$.selected" [checked]="item.selected" /> <span>{{item.name}}</span>
                    </div>
                  </ng-template>
                </ng-select>
                </div> 
            <div *ngIf="showClear">
              <button type="button" class="btn btn-warning clear-text " (click)="clearAllFilter()">
                {{'home.productHeader.ClearFilter' | cxTranslate }}</button>
            </div> 
          </div>
          <div class="ml-auto d-flex">
            <div class="mr-4 d-none d-lg-block">
              <div class="d-flex" *ngIf="this.display=='delivery'">
              <a (click)="donwloadReport('batches_report')" class="mr-2 mt-2" >{{'shipment.Export' | cxTranslate}}</a>
              <button (click)="donwloadReport('batches_report')" type="button" class="float-right btnheight d-none d-sm-block btn btn-secondary" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false"><img src="./images/download_report.svg" alt="customlogo" width="25px" height="25px"> &nbsp;
              {{'shipment.Export' | cxTranslate}}
            </button>
          </div>
          <div class="d-flex" *ngIf="this.display=='screening' || this.display=='bondedwarehouseScreening'" >
            <a (click)="donwloadReport(section=='portside' ? 'screening_report' : 'bonded_warehouse_screening_report')" class="mr-2 mt-2" >{{'shipment.Export' | cxTranslate}}</a>
              <button (click)="donwloadReport(section=='portside' ? 'screening_report' : 'bonded_warehouse_screening_report')" type="button" class="float-right btnheight d-none d-sm-block btn btn-secondary" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false"><img src="./images/download_report.svg" alt="customlogo" width="25px" height="25px"> &nbsp;
              {{'shipment.Export' | cxTranslate}}
            </button>
          </div>
            <!-- <div  class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
              <a class="dropdown-item" >{{'shipment.batchesreport' | cxTranslate}}</a>
            </div>
            <div  class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
              <a class="dropdown-item" >{{'shipment.screeningreport' | cxTranslate}}</a>
            </div> -->
            </div>
        <!--search function desktop-->
        <div class="d-flex align-items-center mr-2 search-section-col">
          <div class="search-section-div">
            <div class="input-group d-flex align-items-center">
              <input class="form-control form-control-lg border rounded-pill input-field" type="search"
                (keypress)="omitSpecialChar($event)" [(ngModel)]="searchText" (input)="search()"
                placeholder="{{ 'home.productHeader.Search' | cxTranslate }}">
              <span class="input-group-append">
                <button name='searchbuttondesktop'
                  class="btn btnUpgrade rounded-pill border-0 input-field bg-white border-start-0 border-bottom-0 border ms-n5"
                  type="button">
                  <i class="fa fa-search pe-none"></i>
                </button>
              </span>
            </div>
          </div>
        </div>       
      </div>
        </div>
      </div>
      <div class="container d-lg-none">
        <div class="row">
          <div class="w-100">
            <div class="filter-select-div-mobile pl-4">
                <div class="input-group align-items-center">
                  <input class="form-control border rounded-pill input-field" type="search" (input)="search()"
                    (keypress)="omitSpecialChar($event)" [(ngModel)]="searchText" placeholder="{{'shipment.search' | cxTranslate}}">
                  <span class="input-group-append d-flex align-items-center">
                    <button name='searchbuttonfilter' class="
                            btn
                            btnUpgrade
                            border-0
                            input-field
                            border-start-0 border-bottom-0 border
                            ms-n5
                          " type="button">
                    <i class="fa fa-search mobbar"></i>
                  </button>
              <span class="mx-2 line" ></span>
                  <div class="ml-1 dropdown show">
                    <button type="button" *ngIf="this.display=='delivery'" (click)="donwloadReport('batches_report')" style="min-height: auto;"
                      class="float-right btn btn-sm btn-secondary" href="#" role="button"
                      id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img
                        src="/images/download_report.svg" alt="customlogo" width="25px" height="25px">
                      </button>
                    <button *ngIf="this.display=='screening' || this.display=='bondedwarehouseScreening'" type="button" (click)="donwloadReport('screening_report')" style="min-height: auto;"
                      class="float-right btn btn-sm btn-secondary" href="#" role="button"
                      id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img
                        src="/images/download_report.svg" alt="customlogo" width="25px" height="25px">
                      </button>
                    <!-- <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
                        <a  style="min-height: fit-content;" class="dropdown-item"  >{{'shipment.batchesreport' | cxTranslate}}</a>
                        <a style="min-height: fit-content;" class="dropdown-item" >{{'shipment.screeningreport' | cxTranslate}}</a>
                  </div> -->
                  </div>
                  <!-- Add vertical divider between export and filter -->
                  <span class="mx-2 line"></span>
                  <div class='hidden-xs-filter-bar pr-1 ml-1' (click)='filtersidebar()'>
                    <img class="ml-1" src="./images/filternew.svg"><sup class="pl-2 pr-2 pt-1 pb-1"
                      *ngIf='length'>{{length}}</sup>
                    <div class="ff-semibold fs-10 d-flex align-items-center text-black Filternew">{{ 'home.filter.filters' |
                      cxTranslate }}</div>
                  </div>
                </span>
              </div>
            </div>
        </div>
      </div>
      <div class="">
        <div [ngClass]="sidebar ?'hide-mobile-filter-sidebar': 'mobile-filter-sidebar' "
          class="hidden-xs-filter-bar sidebar">
          <div class='sticky-top  d-flex justify-content-between p-3 border sticky'>
            <div class="fs-24 md-semibold-font pl-1">{{ 'home.productHeader.Filter' | cxTranslate }}:</div>
            <div (click)="closebar()"><img src="/images/sidebarcross.svg" alt=""> </div>
          </div>
          <div class="scrollbar">
            <div>
              <div class="d-flex md-semibold-font small pl-3 pt-3 pb-2">{{'shipment.ports' | cxTranslate}} :</div>
              <div *ngFor="let ports of portData; let i=index" class="ml-5 small d-flex line-height">
                <label class="ff-normal" *ngIf="ports.name!==undefined && ports.name!==''">
                  <input type="checkbox" [(ngModel)]="ports.selected" [value]="ports.id"
                    [checked]="ports.selected" (change)="portsmobileFilter($event, ports.id)" />
                  {{ports.name}}
                </label>
              </div>
            </div>
            <div>
              <div class="d-flex md-semibold-font small pl-3 pt-3 pb-2">{{'shipment.status' | cxTranslate}} :</div>
              <div *ngFor="let status of StatusList; let i=index" class="ml-5 small d-flex line-height">
                <label class="ff-normal" *ngIf="status.name!==undefined && status.name!==''">
                  <input type="checkbox" [(ngModel)]="status.selected" [value]="status.code"
                    [checked]="status.selected" (change)="statusmobileFilter($event, status.code)" />
                  {{status.name}}
                </label>
              </div>
            </div>
          </div>
          <div class="sticky-bottom p-4 border-top">
            <button class="btn btn-block btn-primary w-100" (click)="getResults()">{{ 'home.contracts.seeResults'|cxTranslate}}</button>
            <button class='btn btn-block' (click)="clearFilterDataMobile($event);closebar()">{{ 'home.contracts.clearFilter' |
              cxTranslate}}</button>
          </div>
        </div>
      </div>
    </div>
</div>
<div class="container" >
    <div class="row d-flex justify-content-between px-2 pt-4" >
      <div class="col-lg-2 tabDiv">
        <nav class="product-tab ">
          <div class="nav nav-fill nav-tabs pe-auto" id="nav-tab" role="tablist"> 
            <div class="nav-item nav-link active tab-bar strong fs-14" [class.active]="activeTab === 'Active'" id="nav-profile-tab" data-toggle="tab"
              role="tab" aria-controls="nav-profile" aria-selected="true" (click)="changeTab('Active')"
             > {{'shipment.Active' | cxTranslate}}
            </div>
            <div class="nav-item nav-link  tab-bar strong fs-14" [class.active]="activeTab === 'Completed'" id="nav-home-tab" data-toggle="tab"
              role="tab" aria-controls="nav-home" aria-selected="false" (click)="changeTab('Completed')"
             >{{'shipment.Completed' | cxTranslate}}
            </div>
            <!-- <div class="nav-item nav-link  tab-bar strong fs-14" [class.active]="activeTab === 'Completed'" id="nav-home-tab" data-toggle="tab"
              role="tab" aria-controls="nav-home" aria-selected="false" (click)="changeTab('Archived')"
             >Archived
            </div> -->
          </div>
        </nav>
      </div>
      <!-- <div>
        <span class="grid-icon ml-3">Display as:
          <img class="grid-icon" title="grid" [src]='gridSrc' (click)="viewGrid()" >
          <img class="list-icon" title="list" [src]='listSrc' (click)=" viewList()">
      </span>
      </div> -->
    </div>
    <div class="border-bottom"></div>
</div>
<div class="container"  *ngIf="(activeTab==='Active' || activeTab === 'Completed') && !enableLoader"  infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" (scrolled)="onScrollGrid()" [scrollWindow]="true" [infiniteScrollDisabled]="reachedToEnd === true">
    <div *ngIf="dvlTracking && dvlTracking.length === 0 && !enableLoader && this.display=='delivery'" class="text-center strong  text-secondary my-5">
        {{'home.contracts.Noresults' | cxTranslate }}</div>
        <div *ngIf="list==true && this.display=='delivery' " >
            <div class="row flex-wrap" *ngFor="let list of dvlTracking">
                <div class="col-md-12 col-lg-12 " >
                  <div class="card mt-4 mb-4 card-border border-radius-05">
                      <div [ngStyle]="{'background-color':list.batchStatusCode === 'NEW'?'#0A6CB4': list.batchStatusCode === 'INPROGRESS'? '#dd5900':list.batchStatusCode === 'ARCHIVED' ? ' #464646' :list.batchStatusCode === 'ASSIGNED' ? '#06AD96' : '#6C757D'}"
                      class="card-header borderRadius pb-1">
                        <!-- Desktop View -->
                        <div class='d-flex justify-content-between'>
                          <div class=""><span class="mr-1"><img class="mb-1" src="./images/ship.svg" alt="icon" width="35" height="16"></span>{{list.batchId}}</div>
                          <div class="d-flex justify-content-between ">
                          <span  class="mr-3 d-none d-md-block d-lg-block">{{ 'home.quote.Creationdate' | cxTranslate }} {{convertDateOnly(list.batchCreationDate)}}</span>
                          <div *ngIf="list.batchStatusCode == 'NEW'" class="badge badge-light ml-auto fs-12">{{list.batchStatus}}</div>
                          <div *ngIf="list.batchStatusCode == 'INPROGRESS'" class="badge badge-blue ml-auto fs-12">{{list.batchStatus}}</div>
                          <div *ngIf="list.batchStatusCode == 'ASSIGNED'" class="badge badge-color ml-auto fs-12">{{list.batchStatus}}</div>
                          </div>
                        </div>
                         </div>
                        <div class="card-body d-none d-lg-block pb-0">
                            <div class='d-flex py-2 text-break'>
                              <div class="d-none d-md-block d-lg-block col-md-2 p-ship">
                                <div class="h5 mb-0 strong">{{list.vesselName}}</div>
                                <div class="small text-secondary">{{list.portName}}</div>
                            </div>
                            <div class="d-none d-md-block d-lg-block col-md-2">
                                <div class="small text-secondary">{{'batches.material' | cxTranslate}}</div>
                                <div class="small text-black" *ngIf="this.display=='delivery'">{{list.productName}}</div>
                            </div>
                            <div class="col-md-6">
                              <div class="row">
                            <div class="d-none d-md-block d-lg-block col-md-3">
                                <div class="small text-secondary">{{'batches.quantity' | cxTranslate}}</div>
                                <div class="small text-nowrap">{{list.quantity?list.quantity:'--'  }}</div>
                            </div>
                            <div *ngIf="this.display=='delivery'" class="d-none d-md-block d-lg-block col-md-3">
                              <div class="small text-nowrap text-secondary">{{'batches.deliveredInventory' | cxTranslate}}</div>
                              <div class="small text-nowrap">{{list.deliveredInventory?list.deliveredInventory:'--' }}</div>
                            </div>
                            <div *ngIf="this.display=='delivery'" class="d-none d-md-block d-lg-block col-md-3">
                              <div class="small text-nowrap text-secondary">{{'batches.remainingInventory' | cxTranslate}}</div>
                              <div class="small text-nowrap">{{list.remainingInventory?list.remainingInventory:'--' }}</div>
                            </div>
                            <div *ngIf="this.display=='delivery'" class="d-none d-md-block d-lg-block col-md-3">
                                <div class="small text-nowrap text-secondary">{{'batches.batchCompleted' | cxTranslate}}</div>
                                <div [ngStyle]="{'background-color':list.isBatchCompleted === false?'#01515F':'#28A745'}"
                                class="small text-white badge">{{list.isBatchCompletedLocale}}</div>
                            </div> 
                            </div>
                            </div>
                            <div *ngIf="this.display=='delivery'" class="d-none d-md-block d-lg-block  col-md-2">
                              <div class="small text-secondary">{{'batches.cargoagent' | cxTranslate}}</div>
                              <div class="small">{{list.portSidePartner?list.portSidePartner:'UnASSIGNED'}}</div>
                            </div> 
                            </div>                            
                        </div>
                         <!-- Mobile View Active/Completed tab -->
                         <div class="py-2 d-lg-none">
                        <span class="small text-secondary ml-3">{{ 'home.quote.Creationdate' | cxTranslate }} {{convertDateOnly(list.batchCreationDate)}}</span>
                          <div class="px-3 row mt-3">
                             <div class="h5 mb-0 strong col-6" *ngIf="this.display=='delivery'">{{list.portName}}</div>
                               <div class="small text-secondary col-6" *ngIf="this.display=='delivery'">{{list.vesselName}}</div>
                           </div>
                       </div>
                       <div class="hr d-lg-none">
                       <div class="row px-3 mt-3">
                           <div class="col-6 small strong">{{'batches.material' | cxTranslate}}</div>
                           <div class="col-6 small text-black" >{{list.productName}}</div>
                       </div>
                       <div class="row px-3 mt-3">
                           <div class="col-6 small strong text-secondary">{{'batches.quantity' | cxTranslate}}</div>
                           <div class="col-6 small" >{{list.quantity?list.quantity:'--'}}</div>
                       </div>
                       <div >
                       <div class="row px-3 mt-3">
                         <div class="col-6 small strong text-secondary">{{'batches.deliveredInventory' | cxTranslate}}</div>
                         <div class="col-6 small">{{list.deliveredInventory?list.deliveredInventory:'--' }}</div>
                       </div>
                       <div class="row px-3 mt-3">
                         <div class="col-6 small text-secondary">{{'batches.remainingInventory' | cxTranslate}}</div>
                         <div class="col-6 small">{{list.remainingInventory?list.remainingInventory:'--'}}</div>
                       </div>
                       <div class="row px-3 mt-3">
                           <div class="col-6 small strong text-secondary">{{'batches.batchCompleted' | cxTranslate}}</div>
                           <div class="col-6"><div class="small text-white badge" [ngStyle]="{'background-color':list.isBatchCompleted === false?'#01515F':'#28A745'}"
                           >{{list.isBatchCompletedLocale}}</div></div>                      
                          </div> 
                       <div class="row px-3 mt-3">
                         <div class="col-6 small strong text-secondary">{{'batches.cargoagent' | cxTranslate}}</div>
                         <div class="col-6 small">{{list.portSidePartner?list.portSidePartner:'UnASSIGNED'}}</div>
                       </div>  
                       </div>
                      </div> 
                           
                            <!-- End Mobile view  -->
                        <div class="hr mt-0 mb-3"></div>
                        <div class="mx-3 mb-3 d-flex justify-content-between">
                            <div class="col-md-4 mt-2" *ngIf="this.display=='delivery'">
                                <div class="strong text-primary pe-auto ml-2" (click)="goToDetails(list)">
                                    {{'shipment.Viewdetails' | cxTranslate}} ></div>
                            </div>
                     <div class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center col-12 col-lg-auto ml-lg-auto mr-lg-5 small text-secondary mt-2 mt-lg-0">
                    <div class="mr-lg-4 mb-1 mb-lg-0">
                      <span>{{'batches.inspection_agent' | cxTranslate}}:</span>
                      <span class="text-blue text-decoration-underline pe-auto ml-2"
                        (click)="openCargoAgentPopup('inspection_agent', list)">{{list.inspectionAgent?.name ? list.inspectionAgent?.name : 'Unassigned'}}</span>
                    </div>
                    <div>
                      <span>{{'batches.screening_operator' | cxTranslate}}:</span>
                      <span class="text-blue text-decoration-underline pe-auto ml-2"
                        (click)="openCargoAgentPopup('screening_operator', list)">{{list.screeningAgent?.name ? list.screeningAgent?.name : 'Unassigned'}}</span>
                    </div>
                  </div>
 
               
                          <!-- <div  class="mr-3">
                              <button class="btn btn-sm btn-light border rounded pl-5 pr-5 btnheight bg-transparent">{{'shipment.Assign' | cxTranslate}}</button>
                            </div> -->
                               <div *ngIf="(list.batchStatusCode === 'COMPLETED' && isAgentInvoiceActive=='true')">
                            <button class="btn btn-sm strong text-primary btn-light border rounded btnheight pl-5 pr-5 bg-transparent"
                              (click)="openInvoices(list)">{{'shipment.invoice.attachInvoice' | cxTranslate}}</button>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="batchesScreening && batchesScreening.length === 0 && !enableLoader && (this.display=='screening' || this.display=='bondedwarehouseScreening')" class="text-center strong  text-secondary my-5">
          {{'home.contracts.Noresults' | cxTranslate }}</div>
        <div *ngIf="list==true && (this.display=='screening' || this.display == 'bondedwarehouseScreening')">
          <div class="row flex-wrap" *ngFor="let dvlscreen of batchesScreening">
              <div class="col-md-12 col-lg-12 " >
                <div class="card mt-4 mb-4 card-border border-radius-05">
                    <div [ngStyle]="{'background-color':dvlscreen.screeningStatusCode === 'NEW'?'#0A6CB4': dvlscreen.screeningStatusCode === 'INPROGRESS'? '#dd5900':dvlscreen.screeningStatusCode === 'ARCHIVED' ? ' #464646' :dvlscreen.screeningStatusCode === 'ASSIGNED' ? '#06AD96' : '#6C757D'}"
                    class="card-header borderRadius pb-1">
                          <div class="d-flex justify-content-between">
                            <div class=""><span class="mr-1"><img class="mb-1" src="./images/ship.svg" alt="icon" width="35" height="16"></span>{{dvlscreen.batchId}}</div>
                            <div class="d-flex justify-content-between">
                            <span class="mr-3 d-none d-md-block d-lg-block">{{ 'home.quote.Creationdate' | cxTranslate }} {{convertDateOnly(dvlscreen.batchCreationDate)}}</span>
                            <div *ngIf="dvlscreen.screeningStatusCode == 'NEW'" class="badge badge-light ml-auto fs-12">{{dvlscreen.screeningStatus}}</div>
                            <div *ngIf="dvlscreen.screeningStatusCode == 'INPROGRESS'" class="badge badge-blue ml-auto fs-12">{{dvlscreen.screeningStatus}}</div>
                            <div *ngIf="dvlscreen.screeningStatusCode == 'ASSIGNED'" class="badge badge-color ml-auto fs-12">{{dvlscreen.screeningStatus}}</div>
                            <div *ngIf="dvlscreen.screeningStatusCode == 'COMPLETED'" class="badge badge-wheat text-black ml-auto fs-12">{{dvlscreen.screeningStatus}}</div>
                          </div>
                        </div>
                      </div>
                      <div class="card-body d-none d-lg-block pb-0">
                          <div class='d-flex py-2  text-break'>
                            <div class="d-none d-md-block d-lg-block col-md-2 p-ship">
                              <div class="h5 mb-0 strong">{{dvlscreen.vesselName}}</div>
                              <div class="small text-secondary">{{dvlscreen.portName}}</div>
                            </div>
                          <div class="d-none d-md-block d-lg-block col-md-2">
                              <div class="small text-secondary">{{'batches.material' | cxTranslate}}</div>
                              <div class="small text-black" >{{dvlscreen.productName}}</div>
                          </div>
                          <div class="col-md-6">
                            <div class="row">
                          <div class="d-none d-md-block d-lg-block col-md-3">
                              <div class="small text-secondary">{{'batches.quantity' | cxTranslate}}</div>
                              <div class="small text-nowrap">{{dvlscreen.quantity?dvlscreen.quantity:'--'  }}</div>
                          </div>
                          <div  class="d-none d-md-block d-lg-block col-md-3">
                            <div class="small text-nowrap text-secondary">{{'batches.screenedNblu' | cxTranslate}}</div>
                            <div class="small">{{dvlscreen.screenedNblluQty}}</div>
                          </div>
                          <div  class="d-none d-md-block d-lg-block col-md-3">
                            <div class="small text-nowrap text-secondary">{{'batches.actualNbslqty' | cxTranslate}}</div>
                            <div class="small">{{dvlscreen.actualNbslQty}}</div>
                          </div>
                          <div  class="d-none d-md-block d-lg-block col-md-3">
                            <div class="small text-nowrap text-secondary">{{'batches.NbsfNbllration' | cxTranslate}}</div>
                            <div class="small">{{dvlscreen.nbsfNblluRatio}} %</div>
                          </div> 
                          </div> 
                          </div>
                          <div  class="d-none d-md-block d-lg-block col-md-2">
                            <div class="small text-nowrap text-secondary">{{'batches.screening_operator' | cxTranslate}}</div>
                            <div class="small">{{dvlscreen.screeningOperator}}</div>
                          </div>
                          </div>                            
                      </div>
                       <!-- Mobile View Active/Completed tab -->
                       <div class="py-2 d-lg-none">
                      <span class="ml-2 text-secondary small">{{ 'home.quote.Creationdate' | cxTranslate }} {{convertDateOnly(dvlscreen.batchCreationDate)}}</span>
                        <div class="px-3 row mt-3 ">
                           <div class="col-6 h5 mb-0 strong" >{{dvlscreen.portName}}</div>
                             <div class="col-6 small text-secondary" >{{dvlscreen.vesselName}}</div>
                         </div>
                     </div>
                     <div class="hr d-lg-none">
                     <div class="row px-3 mt-3">
                         <div class="col-6 small strong">{{'batches.material' | cxTranslate}}</div>
                         <div class="col-6 small text-black" >{{dvlscreen.productName}}</div>
                     </div>
                     <div class="row px-3 mt-3">
                         <div class="col-6 small strong text-secondary">{{'batches.quantity' | cxTranslate}}</div>
                         <div class="col-6 small" >{{dvlscreen.quantity?dvlscreen.quantity:'--'}}</div>
                     </div>
                     <div >
                      <div class="row px-3 mt-3">
                        <div class="col-6 small strong text-secondary">{{'batches.screenedNblu' | cxTranslate}}</div>
                        <div class="col-6 small">{{dvlscreen.screenedNblluQty}}</div>
                      </div>
                      <div class="row px-3 mt-3">
                        <div class="col-6 small text-secondary">{{'batches.actualNbslqty' | cxTranslate}}</div>
                        <div class="col-6 small">{{dvlscreen.actualNbslQty}}</div>
                      </div>
                      <div class="row px-3 mt-3">
                          <div class="col-6 small strong text-secondary">{{'batches.NbsfNbllration' | cxTranslate}}</div>
                          <div class="col-6 small">{{dvlscreen.nbsfNblluRatio}} %</div>                      
                         </div> 
                        <div class="row px-3 mt-3">
                          <div class="col-6 small strong text-secondary">{{'batches.screening_operator' | cxTranslate}}</div>
                          <div class="col-6 small">{{dvlscreen.screeningOperator}}</div>                      
                         </div> 

                      </div>

                    </div> 
                         
                          <!-- End Mobile view  -->
                      <div class="hr"></div>
                      <div class="row mb-3 align-items-center" *ngIf="this.display=='screening' || this.display=='bondedwarehouseScreening'">
                          <div class="col-md-2 ml-4" >
                            <div class="strong text-primary pe-auto ml-2" (click)="goToScreeningDetails(dvlscreen)">
                                {{'shipment.Viewdetails' | cxTranslate}} ></div>
                        </div>
              <div class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center col-12 col-lg-auto ml-lg-auto mr-lg-5 small text-secondary mt-2 mt-lg-0">
                <div class="mr-lg-4 mb-1 mb-lg-0">
                      <span>{{'batches.cargoagent' | cxTranslate}}:</span>
                      <span class="text-blue text-decoration-underline pe-auto ml-2"
                        (click)="openCargoAgentPopup('cargo_agent', dvlscreen)">{{dvlscreen.cargoAgent?.name ? dvlscreen.cargoAgent?.name : 'Unassigned'}}</span>
                    </div>
                    <div class="mr-lg-4 mb-1 mb-lg-0">
                      <span>{{'batches.inspection_agent' | cxTranslate}}:</span>
                      <span class="text-blue text-decoration-underline pe-auto ml-2"
                        (click)="openCargoAgentPopup('inspection_agent', dvlscreen)">{{dvlscreen.inspectionAgent?.name ? dvlscreen.inspectionAgent?.name : 'Unassigned'}}</span>
                    </div>
                    <div class="d-flex align-items-center mt-2 mt-lg-0" *ngIf="(dvlscreen.screeningStatusCode === 'COMPLETED' && isAgentInvoiceActive=='true')">
                         <button  class="btn btn-sm strong text-primary btn-light border rounded btnheight pl-5 pr-5 ml-3 bg-transparent"
                              (click)="openPortInvoices(dvlscreen)">{{'shipment.invoice.AttachScreeningInvoices' |
                            cxTranslate}}</button>
                      </div>

                  </div>
                        <!-- <div class="d-md-none d-lg-none mt-2" *ngIf="this.display=='screening'">
                            <div class="strong text-primary pe-auto ml-2" (click)="goToScreeningDetails(dvlscreen)">
                                {{'shipment.Viewdetails' | cxTranslate}} ></div>
                        </div> -->                     
                          <!-- <div  class="mr-3">
                            <button class="btn btn-sm btn-light border rounded pl-5 pr-5 btnheight bg-transparent">{{'shipment.Assign' | cxTranslate}}</button>
                          </div> -->
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div id="loaderScroll" *ngIf="enableLoaderScoll"></div>
        </div>
      </div>
<!-- <div>
    <button class="btn btn-primary" (click)="goToDetails()">Delivery Details</button>
</div>
<br>
<div>
    <button class="btn btn-primary" (click)="recordPickUpModal()">Record Pick Up</button>
</div> -->
